import type { Composer } from 'vue-i18n';
import type { DataTableColumn } from './types';

/**
 * Shared product image thumbnail column config — used by SOStockTable,
 * SOProductsTable, and SOProductSelector.
 */
export function imageColumn(t: Composer['t']): DataTableColumn {
  return {
    data: 'so_product_primary_image_thumbnail_url',
    title: t('Imagem'),
    width: 80,
    sortable: false,
    renderType: 'image',
    imageConfig: {
      width: 44,
      emptyIcon: 'pi pi-image',
      alt: (row: Record<string, unknown>): string => String(row.so_product_name ?? '')
    }
  };
}

/**
 * Shared product name column config.
 */
export function productNameColumn(t: Composer['t'], width: number = 200): DataTableColumn {
  return {
    data: 'so_product_name',
    title: t('Produto'),
    width,
    sortable: true,
    filterType: 'text'
  };
}

/**
 * Shared "Franquia" column config. When `withGlobalFallback` is true, adds a
 * cell renderer that shows "Catálogo global" if the franchise name is empty.
 */
export function franchiseColumn(t: Composer['t'], dataKey: string, withGlobalFallback = false): DataTableColumn {
  const col: DataTableColumn = { data: dataKey, title: t('Franquia') };
  if (withGlobalFallback) {
    col.cellRenderer = ({ value }: { value: unknown }): string =>
      value ? String(value) : t('Catálogo global');
  }
  return col;
}

/**
 * Shared currency price column config.
 */
export function priceColumn(t: Composer['t'], dataKey: string, title: string, width: number = 120): DataTableColumn {
  return {
    data: dataKey,
    title,
    width,
    sortable: true,
    renderType: 'currency'
  };
}
